module.exports = __webpack_public_path__ + "static/media/crossplat.d9a30c94.png";


//////////////////
// WEBPACK FOOTER
// ./src/Jiggle/Implementation/img/crossplat.png
// module id = 293
// module chunks = 0